import React, {useEffect, useMemo, useState} from 'react'
import {Box, Container, Stack} from '@mui/material'
import Page from 'components/Page/Page'
import {useGetMetersDashboardQuery} from 'store/Store'
import DashboardHeader from 'components/Page/Dashboard/DashboardHeader'
import AttentionPanel from 'components/Page/Dashboard/AttentionPanel'
import KpiRow from 'components/Page/Dashboard/KpiRow'
import ConsumptionChart from 'components/Page/Dashboard/ConsumptionChart'
import BillingChart from 'components/Page/Dashboard/BillingChart'
import TopConsumers from 'components/Page/Dashboard/TopConsumers'
import {DEFAULT_CATEGORY} from 'components/Page/Dashboard/dashboardFormat'

const Dashboard = () => {
    const [category, setCategory] = useState(DEFAULT_CATEGORY)
    const {data: meters} = useGetMetersDashboardQuery({category})
    const categories = useMemo(() => meters?.categories || [], [meters])

    // The account may only have e.g. water meters; fall back to a category that exists.
    useEffect(() => {
        if (categories.length && !categories.includes(category)) setCategory(categories[0])
    }, [categories, category])

    return (
        <Page>
            <Container maxWidth="xxl">
                <Stack spacing={3} sx={{py: 3}}>
                    <DashboardHeader
                        category={category}
                        categories={categories}
                        onCategoryChange={setCategory}
                    />
                    <AttentionPanel category={category} />
                    <KpiRow category={category} />
                    <ConsumptionChart category={category} />
                    <Box
                        sx={{
                            display: 'grid',
                            gap: 3,
                            gridTemplateColumns: {xs: '1fr', lg: '7fr 5fr'},
                        }}>
                        <BillingChart />
                        <TopConsumers category={category} />
                    </Box>
                </Stack>
            </Container>
        </Page>
    )
}

export default Dashboard
